import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import ContactImg from '../assets/images/contact.jpg';
import TitleImage from '../components/TitleImage';


//styled components.
import {  TitleWrapper, TitleDesc } from '../components/StyledComponents/StyledComp';
import Menu from '../components/Menu';
import Layoutsvg from '../components/Layoutsvg';

//importing animations
import { MainNameVariants, MainLine1Variants, MainLine2Variants, MainRoleVariants } from '../animations/MainPageAnims';
import Links from '../components/Links';


function Contact() {
    const navigate = useNavigate();
    var scrolled = false;
    function handleScroll(e) {

        if (!scrolled) {
            const y = e.wheelDeltaY;
            if (y > 0) {
                scrolled = true;
                // console.log("scrolled with project");
                navigate("/projects");
            }
            // setTimeout(()=> scrolled=false , 2000);
        }
    }

    useEffect(() => {
        scrolled = false;
        setTimeout(() => {

            //FOR MOBILE
            let touchstartX = null;
            let touchendX = null;
            let touchstartY = 0;
            let touchendY = 0;
            function handleGesture(e) {
                if (!scrolled) {

                    var diffX = touchstartX - touchendX;
                    var diffY = touchstartY - touchendY;

                    if (Math.abs(diffX) < Math.abs(diffY)){
                        if (diffY > 0) {
                            // swiped up
                            // console.log("swiped up");
                          } else {
                            // swiped down
                            // console.log("swiped down");
                            navigate('/projects');
                          }  
                    }
                }
            }

            const wrapper = document.querySelector(".contact-wrapper");


            if (wrapper) {
                wrapper.addEventListener('touchstart', e => {
                    touchstartX = e.touches[0].clientX;
                    touchstartY = e.touches[0].clientY;
                });
                wrapper.addEventListener('touchmove', e => {
                    if (touchstartX === null ||  touchstartY === null) {
                        return;
                    }

                    touchendX = e.touches[0].clientX;
                    touchendY = e.touches[0].clientY;
                    handleGesture();
                });
                wrapper.addEventListener("wheel", handleScroll);
            }
        }, 1500);
    }, []);

    return (
        <TitleWrapper className='contact-wrapper' >
            <Layoutsvg />
            <Menu />
            <motion.div
            >
                <TitleDesc>
                    <motion.p className="title-text"
                        variants={MainNameVariants} initial="initial" animate="animate"
                    >Get In Touch</motion.p>
                    <motion.div className="redline1"
                        variants={MainLine1Variants} initial="initial" animate="animate"
                    ></motion.div>
                    <motion.div className="redline2"
                        variants={MainLine2Variants} initial="initial" animate="animate"
                    ></motion.div>
                    <motion.div className="role"
                        variants={MainRoleVariants} initial="initial" animate="animate"
                    >
                        <Mail className='title-lead mail clickable' >devbatra1000@gmail.com</Mail>
                        <Links />
                    </motion.div>
                </TitleDesc>
                <TitleImage pageNumber="03" photoSource={ContactImg} />
            </motion.div>
        </TitleWrapper>
    );
}

const Mail = styled.p`
    margin-bottom: 2rem;
`;



export default Contact;